import { render, staticRenderFns } from "./ProjectReprintHeaderFooterText.vue?vue&type=template&id=77e1c30c&scoped=true&lang=pug&"
import script from "./ProjectReprintHeaderFooterText.vue?vue&type=script&lang=ts&"
export * from "./ProjectReprintHeaderFooterText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e1c30c",
  null
  
)

export default component.exports